import { render, staticRenderFns } from "./home-module.vue?vue&type=template&id=008b8a88&scoped=true"
import script from "./home-module.vue?vue&type=script&lang=js"
export * from "./home-module.vue?vue&type=script&lang=js"
import style0 from "./home-module.vue?vue&type=style&index=0&id=008b8a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b8a88",
  null
  
)

export default component.exports